import React from "react";

export default function Section({ buttonEnabled, leftSectioned, bgColor, label, description, image, onClicked, tag }) {
  const containerStyle = `w-full flex flex-col items-center justify-center ${bgColor} py-10 ${
    leftSectioned ? "md:flex-row" : "md:flex-row-reverse"
  }`;

  const imageContainerStyle = `w-full md:w-3/5 md:h-[38rem]`;

  return (
    <div className={containerStyle}>
      <div className={imageContainerStyle}>
        <div className="h-full w-full rounded-lg overflow-hidden">
          <img src={image} alt="Section visual" className="w-full h-full object-cover" />
        </div>
      </div>

      <div className="w-full md:w-2/5 h-full text-left px-[1rem] pt-[1.5rem] md:mx-[3rem]">
        {tag && <span className="inline-flex items-center rounded-full p-3 py-1 mb-3 -ml-2 text-sm font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10">
          {tag}
        </span>}
        <h2 className="text-[2.75rem] md:text-[3rem] leading-none text-black font-segoe font-semibold text-left mb-3 pb-[1rem] mb-[1rem] md:pb-[2rem] md:mb-[2rem]">{label}</h2>
        <p className="text-[0.90rem] md:text-[1.05rem] text-black font-segoe text-justify mb-[2rem]">{description}</p>
        {buttonEnabled && (
          <button className="cursor-pointer rounded-full text-white font-roboto font-semibold bg-primary px-[2rem] py-[0.5rem]" onClick={onClicked}>
            Learn more
          </button>
        )}
      </div>
    </div>
  );
}
